import { Component } from '@theme/component';

class DeluluCollectionTools extends Component {
  #abort;

  connectedCallback() {
    super.connectedCallback();
    this.#abort?.abort();
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    this.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLSelectElement)) return;
      if (!event.target.matches('[data-collection-select]')) return;
      const url = new URL(event.target.value, window.location.origin);
      if (url.origin === window.location.origin) window.location.assign(url.href);
    }, { signal });
    this.addEventListener('submit', (event) => {
      if (!(event.target instanceof HTMLFormElement) || !event.target.matches('[data-collection-sort-form]')) return;
      if (!(event.submitter instanceof HTMLButtonElement)) return;
      event.preventDefault();
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.submitter.value);
      url.searchParams.delete('page');
      url.hash = '';
      window.location.assign(url.href);
    }, { signal });
    if (this.querySelector('[data-collection-sort-menu]')) {
      this.addEventListener('toggle', () => this.#fitSortMenu(), { capture: true, signal });
      window.addEventListener('resize', () => this.#fitSortMenu(), { signal });
      window.addEventListener('scroll', () => this.#fitSortMenu(), { capture: true, passive: true, signal });
      document.addEventListener('click', (event) => {
        if (event.target instanceof Node && !this.contains(event.target)) this.#closeSortMenu();
      }, { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !this.querySelector('[data-collection-sort-menu][open]')) return;
        event.preventDefault();
        this.#closeSortMenu();
        this.querySelector('summary')?.focus();
      }, { signal });
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget instanceof Node && !this.contains(event.relatedTarget)) this.#closeSortMenu();
      }, { signal });
    }
    this.addEventListener('click', (event) => {
      const link = event.target.closest('[data-collection-surprise]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const cards = [...this.closest('results-list').querySelectorAll('.product-grid__item product-card a[href*="/products/"]')];
      const urls = [...new Set(cards.map((card) => card.href))];
      if (!urls.length) return;
      event.preventDefault();
      window.location.assign(urls[Math.floor(Math.random() * urls.length)]);
    }, { signal });
  }

  #closeSortMenu() {
    this.querySelector('[data-collection-sort-menu]')?.removeAttribute('open');
  }

  #fitSortMenu() {
    const menu = this.querySelector('[data-collection-sort-menu][open]');
    if (!menu) return;
    const bottom = menu.querySelector('summary').getBoundingClientRect().bottom;
    this.style.setProperty('--sort-menu-max-height', `${Math.max(44, window.innerHeight - bottom - 22)}px`);
  }

  disconnectedCallback() {
    this.#abort?.abort();
    super.disconnectedCallback();
  }
}

if (!customElements.get('delulu-collection-tools')) customElements.define('delulu-collection-tools', DeluluCollectionTools);
